module.exports = __webpack_public_path__ + "static/media/sv.2b59b54c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sv.svg
// module id = 2216
// module chunks = 0